import { useAppAbility } from '@/core/plugins/casl/useAppAbility';
import { Roles } from '@/store/enums/hrgs/RolesEnum';
export const useRoles = () => {
    const { can } = useAppAbility();
    return {
        isAsesi: can('read', Roles.regularUser),
        isAssessor: can('read', Roles.assessor),
        isAdmin: can('read', Roles.adminHO) || can('read', Roles.adminSite),
        isSuperUser: can('read', Roles.superUser),
        isAllAdmin: can('read', Roles.adminHO) ||
            can('read', Roles.adminSite) ||
            can('read', Roles.superUser)
    };
};
